module.exports = __webpack_public_path__ + "img/flow-img3-2.fe2aa21f.png";